import { ManageJobsUI } from 'features'

const ManageJobs = () => {
  return (
    <div>
      <ManageJobsUI />
    </div>
  )
}

export { ManageJobs }
